import { createContext } from 'react';

import { defaultThreshold } from '../constants/defaults.js';
import { HistogramThresholdsConfig } from '../types/histogram.js';

export const HistogramThresholdContext =
  createContext<HistogramThresholdsConfig>(defaultThreshold);

HistogramThresholdContext['displayName'] = 'HistogramThresholdContext';
